<template>
  <div
    class="card-details"
    v-b-tooltip.hover="{ variant: 'base' }"
    :title=getTitle
  >
    {{ getDetails }}
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object
    }
  },
  computed: {
    getBankCardSummary () {
      return this.card.bank_card ? this.card.bank_card.summary : null
    },
    getTitle () {
      return this.getBankCardSummary && this.getCardDetails
    },
    getDetails () {
      return this.getBankCardSummary || this.getCardDetails
    },
    getCardDetails () {
      if (this.card.bank_detail) return this.card.bank_detail.summary
      if (this.card.bank_card) return this.card.bank_card.bank_details.summary
      return ''
    }
  }
}
</script>
